import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";
import { showToastNotification } from "../components/common/ui/NotificationModal/ToastNotication";

const CategoryForm = {
  title: "",
  committee: "",
};
// create slice
const name = "category";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();
// const extraReducers = createExtraReducers();
const slice = createSlice({
  name,
  initialState,
  reducers,
  extraReducers: (builder) => {
    createExtraReducers(builder);
  },
  // extraReducers,
});

// exports

export const categoryActions = { ...slice.actions, ...extraActions };
export const categoryReducer = slice.reducer;

function createInitialState() {
  return {
    categoryForm: CategoryForm,
    categoryList: {},
    categoryByIdList: {},
    CreateCategoryResponse: {},
    changeUserStatusResponse: {},
    updatecategoryResponse: {},
    CategoryDropdownlist: {},
    loading: false,
  };
}

function createReducers() {
  return {
    updateCategoryForm,
    resetCategoryForm,
    setCommittieID,
  };
}

function setCommittieID(state, action) {
  state.committeeID = action?.payload;
}

function updateCategoryForm(state, action) {
  state.categoryForm = action?.payload;
}

function resetCategoryForm(state, action) {
  state.categoryForm = CategoryForm;
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}`;

  return {
    getCategoryList: getCategoryList(), //master committee list
    getCategoryByID: getCategoryByID(), //master get for edit
    CreateCategory: CreateCategory(), //master create
    updateCategory: updateCategory(), //master update
    categoryStatusChange: categoryStatusChange(),
    getCategoryLabel: getCategoryLabel(),
  };

  /* get Category Label for dropDown */
  function getCategoryLabel() {
    return createAsyncThunk(`${name}/getCategoryLabel`, async (params) => {
      return await fetchWrapper.get(`${baseUrl}/category/labels/${params}`);
    });
  }

  /* get committee list */
  function getCategoryList() {
    return createAsyncThunk(`${name}/getCategoryList`, async (params) => {
      return await fetchWrapper.get(`${baseUrl}/category${params}`);
    });
  }

  /* get committee by ID */
  function getCategoryByID() {
    return createAsyncThunk(
      `${name}/getCategoryByID`,
      async (id) => await fetchWrapper.get(`${baseUrl}/category/${id}`)
    );
  }

  /* create new committee */
  function CreateCategory() {
    return createAsyncThunk(
      `${name}/CreateCategory`,
      async (params) => await fetchWrapper.post(`${baseUrl}/category`, params)
    );
  }

  /* create update committee */
  function updateCategory() {
    return createAsyncThunk(`${name}/updateCategory`, async ({ id, data }) => {
      return await fetchWrapper.patch(`${baseUrl}/category/${id}`, data);
    });
  }

  /* change category status*/
  function categoryStatusChange() {
    return createAsyncThunk(
      `${name}/categoryStatusChange`,
      async (params) =>
        await fetchWrapper.patch(`${baseUrl}/category/${params.id}/status`)
    );
  }
}

function createExtraReducers(builder) {
  builder
    //committee list
    .addCase(extraActions.CreateCategory.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.CreateCategory.fulfilled, (state, action) => {
      state.loading = false;
      state.CreateCategoryResponse = action?.payload;
    })
    .addCase(extraActions.CreateCategory.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
      showToastNotification(action.error.message, "error");
    })

    //
    .addCase(extraActions.getCategoryList.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.getCategoryList.fulfilled, (state, action) => {
      state.loading = false;
      state.categoryList = action?.payload;
    })
    .addCase(extraActions.getCategoryList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
      showToastNotification(action.error.message, "error");
    })

    //

    .addCase(extraActions.getCategoryByID.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.getCategoryByID.fulfilled, (state, action) => {
      state.loading = false;
      state.categoryByIdList = action?.payload;
    })
    .addCase(extraActions.getCategoryByID.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
      showToastNotification(action.error.message, "error");
    })
    // //create committee
    .addCase(extraActions.categoryStatusChange.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.categoryStatusChange.fulfilled, (state, action) => {
      state.loading = false;
      state.changeUserStatusResponse = action?.payload;
    })
    .addCase(extraActions.categoryStatusChange.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
      showToastNotification(action.error.message, "error");
    })

    //Update Category

    .addCase(extraActions.updateCategory.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.updateCategory.fulfilled, (state, action) => {
      state.loading = false;
      state.updatecategoryResponse = action?.payload;
    })
    .addCase(extraActions.updateCategory.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
      showToastNotification(action.error.message, "error");
    })

    //labels for category
    .addCase(extraActions.getCategoryLabel.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.getCategoryLabel.fulfilled, (state, action) => {
      state.loading = false;
      state.CategoryDropdownlist = action?.payload?.data;
    })
    .addCase(extraActions.getCategoryLabel.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
      showToastNotification(action.error.message, "error");
    });
}
